import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MaterialModule } from "./material.module";
import { IconSpriteModule } from "ng-svg-icon-sprite";
import { MyIconComponent } from "./my-icon/my-icon.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DialogAlertComponent } from "./dialog-alert/dialog-alert.component";
import { DateInputComponent } from "./date-input/date-input.component";
import { TranslateModule } from "@ngx-translate/core";
import { NameSurnamePipe } from "./pipe/name-surname.pipe";
import { NeedToLoginComponent } from "./need-to-login/need-to-login.component";
import { RouterModule } from "@angular/router";
import { CounterComponent } from "./counter/counter.component";
import { ProductsHeaderComponent } from "./products-header/products-header.component";
import { DialogSmsComponent } from "./dialog-sms/dialog-sms.component";
import { NgOtpInputModule } from "ng-otp-input";
import { ProductDimensionPipe } from "./pipe/product-dimension.pipe";
import { DetailPricesComponent } from "./detail-prices/detail-prices.component";
import { ProductGramPipe } from "./pipe/product-gram.pipe";
import { FooterComponent } from "./footer/footer.component";
import { DialogYesNoComponent } from "./dialog-yes-no/dialog-yes-no.component";
import { OrderDetailsTotalComponent } from "./order-details-total/order-details-total.component";
import { EuroPipe } from "./pipe/euro.pipe";
import { UserAgreementComponent } from "./user-agreement/user-agreement.component";
import { NoCommaPipe } from "./pipe/no-comma.pipe";
import {BREAKPOINT} from '@angular/flex-layout';
import { LanguageSelectorComponent } from "./language-selector/language-selector.component";
import { TermsAndConditionsComponent } from "./terms-and-conditions/terms-and-conditions.component";
import { ProfileShareholderSectionComponent } from "./profile-shareholder-section/profile-shareholder-section.component";
import { DisableCommaPipe } from "./pipe/disable-comma.pipe";
import { ProductFinenessPipe } from "./pipe/product-fineness.pipe";
import { ProductPhotoPipe } from "./pipe/product-photo.pipe";

const PRINT_BREAKPOINTS = [{
  alias: 'xs.print',
  suffix: 'XsPrint',
  mediaQuery: 'print and (max-width: 297px)',
  overlapping: false,
  priority: 1001 // Needed if overriding the default print breakpoint
}];

export const CustomBreakPointsProvider = {
  provide: BREAKPOINT,
  useValue: PRINT_BREAKPOINTS,
  multi: true
};



const modules = [

  MaterialModule,
  IconSpriteModule,
  FlexLayoutModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  RouterModule,
  NgOtpInputModule
];

const components = [
  ProductPhotoPipe,
  ProductFinenessPipe,
  DisableCommaPipe,
  TermsAndConditionsComponent,
  ProfileShareholderSectionComponent,
  LanguageSelectorComponent,
  FooterComponent,
  MyIconComponent,
  DialogAlertComponent,
  DateInputComponent,
  NameSurnamePipe,
  ProductDimensionPipe,
  NeedToLoginComponent,
  CounterComponent,
  ProductsHeaderComponent,
  DialogSmsComponent,
  DetailPricesComponent,
  ProductGramPipe,
  DialogYesNoComponent,
  OrderDetailsTotalComponent,
  EuroPipe,
  UserAgreementComponent,
  NoCommaPipe
];

@NgModule({
  declarations: [components],
  imports: [CommonModule, ...modules],
  exports: [...modules, ...components],
 // providers:[CustomBreakPointsProvider]
})
export class SharedModule { }
